( function( $, document, window ) {
	'use strict';

	// Slick Slideshow
	var $heroSlider = $( document.querySelectorAll( '.hero-slider' ) );

	if ( $heroSlider.length <= 0 ) {
		return;
	}

	$( document ).ready( function() {

		var slickifyHeroSlider = function() {
			$heroSlider.slick( {
				autoplay: false,
				speed: 500,
				arrows: true,
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				mobileFirst: true
			} );
		};

		// Run Slick
		slickifyHeroSlider();

	} );

} )( jQuery, document, window );
